module.exports = __webpack_public_path__ + "img/sCallHB.6053689a.svg";